import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef } from 'react';
import { SearchBar as DefaultSearchBar } from '@united-talent-agency/components';
import { SEARCH } from '../../support/cypressTags';
import { useDebouncedCallback } from 'use-debounce';

const Component = ({ styles, search, updateQuery }, externalRef) => {
  // Refs
  const ref = useRef();

  useImperativeHandle(externalRef, () => ref.current);

  const debouncedUpdateQuery = useDebouncedCallback((query) => {
    updateQuery && updateQuery(query);
  }, 500);

  const handleChange = useCallback(
    ({ target: { value } }) => {
      value = value.replace(/\s+/g, ' ');

      if (value === search.query) {
        return;
      }

      if (!value?.length) {
        debouncedUpdateQuery(undefined);
      } else if (3 <= value.length && value.length <= 50) {
        debouncedUpdateQuery(value);
      }
    },
    [debouncedUpdateQuery, search]
  );

  const handleClear = useCallback(() => {
    updateQuery && updateQuery(undefined);
  }, [updateQuery]);

  /**
   * This is mandatory to visually update the input value.
   */
  useEffect(() => {
    ref.current.value = search?.query ?? '';
  }, [search?.query]);

  return (
    <div className={styles.search}>
      <DefaultSearchBar
        inputRef={ref}
        cypressTag={SEARCH.SEARCH_BAR}
        value={search.query}
        onKeyUp={handleChange}
        onClear={handleClear}
      />
    </div>
  );
};

const SearchBar = forwardRef(Component);

export default SearchBar;
